import { t } from "i18next";

type EntityForStatus =
  | "appointment"
  | "appointmentRequest"
  | "appointmentDashboard"
  | "workerAppointments";

const getTranslatedLabelWithFallback = (label: string) => {
  const translation = t(label);
  if (translation === undefined) {
    return label;
  }
  return translation;
};
export const getTranslatedOptionObject = (
  label: string,
  extendedLabel?: boolean,
  whiteList?: string[]
) => {
  if (whiteList && !whiteList.includes(label)) return;

  let translation = t(`status_${label}`);
  if (translation === undefined) {
    translation = label;
  }
  if (extendedLabel) {
    translation = t(`status_${label}`) + ` (${label})`;
  }
  return { value: label, label: translation };
};

export const statusArray = [
  { value: "open", label: getTranslatedLabelWithFallback("open") },
  {
    value: ["in_progress", "post_processing_required", "scheduled", "approved"],
    label: getTranslatedLabelWithFallback("status_in_progress"),
  },
  {
    value: ["waiting_for_review", "review_preparation_required"],
    label: getTranslatedLabelWithFallback("status_review"),
  },
  {
    value: "completed",
    label: getTranslatedLabelWithFallback("status_completed"),
  },
  {
    value: "canceled",
    label: getTranslatedLabelWithFallback("status_canceled"),
  },
  { value: "missed", label: getTranslatedLabelWithFallback("status_missed") },
  {
    value: "declined",
    label: getTranslatedLabelWithFallback("status_declined"),
  },
  {
    value: "prefilled_by_user",
    label: getTranslatedLabelWithFallback("status_prefilled_by_user"),
  },
];
// -----------------------------------------------------------------------------------------------------

export const statusArrayForAppDashboard = [
  { value: "open", label: getTranslatedLabelWithFallback("open") },
  {
    value: "in_progress",
    label: getTranslatedLabelWithFallback("status_in_progress"),
  },
  {
    value: "completed",
    label: getTranslatedLabelWithFallback("status_completed"),
  },
  {
    value: "canceled",
    label: getTranslatedLabelWithFallback("status_canceled"),
  },
  { value: "missed", label: getTranslatedLabelWithFallback("status_missed") },
  {
    value: "declined",
    label: getTranslatedLabelWithFallback("status_declined"),
  },
  {
    value: "prefilled_by_user",
    label: getTranslatedLabelWithFallback("status_prefilled_by_user"),
  },
];
// -----------------------------------------------------------------------------------------------------
export const statusOptionsForAppointmentRequests = [
  {
    value: "draft",
    label: t("status_draft") + " (draft)",
    translationKey: "status_draft",
    suffix: " (draft)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "open",
    label: t("status_open") + " (open)",
    translationKey: "status_open",
    suffix: " (open)",
    backgroundColor: "#FFF",
  },
  {
    value: "completed",
    label: t("status_completed") + " (completed)",
    translationKey: "status_completed",
    suffix: " (completed)",
    backgroundColor: "#b3ddd8",
  },
];
export const allStatusOptions = [
  {
    value: "draft",
    label: t("status_draft") + " (draft)",
    translationKey: "status_draft",
    suffix: " (draft)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "open",
    label: t("status_open") + " (open)",
    translationKey: "status_open",
    suffix: " (open)",
    backgroundColor: "#FFF",
  },
  {
    value: "review_preperation_required",
    label: t("status_review") + " (review_preperation_required)",
    translationKey: "status_review",
    suffix: " (review_preperation_required)",
    backgroundColor: "#F2F080",
  },
  {
    value: "waiting_for_review",
    label: t("status_review") + " (waiting_for_review)",
    translationKey: "status_review",
    suffix: " (waiting_for_review)",
    backgroundColor: "#F2F080",
  },
  {
    value: "post_processing_required",
    label: t("status_post_processing") + " (post_processing_required)",
    translationKey: "status_post_processing",
    suffix: " (post_processing_required)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "in_progress",
    label: t("status_in_progress") + "( in_progress)",
    translationKey: "status_in_progress",
    suffix: " (in_progress)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "scheduled",
    label: t("status_scheduled") + " (scheduled)",
    translationKey: "status_scheduled",
    suffix: " (scheduled)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "canceled",
    label: t("status_canceled") + " (canceled)",
    translationKey: "status_canceled",
    suffix: " (canceled)",
    backgroundColor: "#ffebee",
  },
  {
    value: "canceled_not_in_time",
    label: t("status_canceled_not_in_time") + " (canceled_not_in_time)",
    translationKey: "status_canceled_not_in_time",
    suffix: " (canceled_not_in_time)",
    backgroundColor: "#ffebee",
  },
  {
    value: "completed",
    label: t("status_completed") + " (completed)",
    translationKey: "status_completed",
    suffix: " (completed)",
    backgroundColor: "#b3ddd8",
  },

  {
    value: "approved",
    label: t("status_approved") + " (approved)",
    translationKey: "status_approved",
    suffix: " (approved)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "missed",
    label: t("status_missed") + " (missed)",
    translationKey: "status_missed",
    suffix: " (missed)",
    backgroundColor: "#f4f2f2",
  },
  {
    value: "declined",
    label: t("status_declined") + " (declined)",
    translationKey: "status_declined",
    suffix: " (declined)",
    backgroundColor: "#f4f2f2",
  },
  {
    value: "prefilled_by_user",
    label: t("status_prefilled_by_user") + " (prefilled_by_user)",
    translationKey: "status_prefilled_by_user",
    suffix: " (prefilled_by_user)",
    backgroundColor: "#f7d1c0",
  },
  {
    value: "waiting_for_lab_results",
    label: t("status_waiting_for_lab_results") + " (waiting_for_lab_results)",
    translationKey: "status_waiting_for_lab_results",
    suffix: " (waiting_for_lab_results)",
    backgroundColor: "#64c0fa",
  },
  {
    value: "evaluating_lab_results",
    label: t("status_evaluating_lab_results") + " (evaluating_lab_results)",
    translationKey: "status_evaluating_lab_results",
    suffix: " (evaluating_lab_results)",
    backgroundColor: "#d6bce9",
  },
];

export const getStatusLabel = (status: string): string => {
  const statusOption = allStatusOptions.find(
    (option) => option.value === status
  );
  return statusOption
    ? `${t(statusOption.translationKey)}${statusOption.suffix}`
    : "";
};

export const getAppointmentDetails = (status: string) => {
  const statusOption = allStatusOptions.find(
    (option) => option.value === status
  );

  const backgroundColor = statusOption?.backgroundColor ?? "#f7d1c0";
  const appointmentStatus = statusOption
    ? t(statusOption.translationKey)
    : t("status_in_progress");

  return { backgroundColor, appointmentStatus };
};

export const getTranslatedStatusOptions = (entity?: EntityForStatus) => {
  let statusArray = allStatusOptions;
  if (entity) {
    switch (entity) {
      case "appointmentRequest":
        statusArray = statusOptionsForAppointmentRequests;
        break;
      default:
        statusArray = allStatusOptions;
    }
  }
  return statusArray.map((option) => ({
    ...option,
    label: t(option.translationKey) + option.suffix,
  }));
};
